import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useProductListingPageContext from 'data-hooks/useProductListingPageContext';
import { PRODUCT_LISTING_MAX_FILTER_OPTIONS } from 'commons/constants';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import Checkbox from 'components/consumer/Checkbox';
const DesktopProductListingListFilter = t0 => {
  const $ = _c(18);
  const {
    id
  } = t0;
  const {
    filters: t1,
    toggleFilterOption
  } = useProductListingPageContext();
  const filters = t1 === undefined ? [] : t1;
  const [showAllOptions, setShowAllOptions] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setShowAllOptions(_temp);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const toggleShowAllOptions = t2;
  let t3;
  if ($[1] !== id) {
    t3 = filter => id === filter.id;
    $[1] = id;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const currentFilter = filters.find(t3);
  if (!currentFilter) {
    return null;
  }
  const isCategoryFilter = id === "category";
  const {
    label,
    options
  } = currentFilter;
  const expandableOptions = !isCategoryFilter && options.length > PRODUCT_LISTING_MAX_FILTER_OPTIONS;
  const optionsToShow = expandableOptions && !showAllOptions ? options.slice(0, PRODUCT_LISTING_MAX_FILTER_OPTIONS) : options;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <VisuallyHidden>Clicking on the following checkboxes will update the content.</VisuallyHidden>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = "space-y-3";
  let t6;
  if ($[4] !== id || $[5] !== toggleFilterOption) {
    t6 = t7 => {
      const {
        id: optionId,
        label: optionLabel,
        isActive,
        isDisabled
      } = t7;
      return <div key={optionId}><Checkbox checked={isActive} disabled={isDisabled} id={optionId} key={id} onClick={() => {
          if (isDisabled) {
            return;
          }
          toggleFilterOption(id, optionId, optionLabel);
        }} size="sm">{optionLabel}</Checkbox></div>;
    };
    $[4] = id;
    $[5] = toggleFilterOption;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = optionsToShow.map(t6);
  let t8;
  if ($[7] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== expandableOptions || $[10] !== label || $[11] !== showAllOptions || $[12] !== toggleShowAllOptions) {
    t9 = expandableOptions && <div><button type="button" className="text-sm font-bold text-brand mt-3" onClick={toggleShowAllOptions} aria-label={!showAllOptions ? `View more ${label} items` : `View fewer ${label} items`}>{!showAllOptions ? "View More" : "View Less"}</button></div>;
    $[9] = expandableOptions;
    $[10] = label;
    $[11] = showAllOptions;
    $[12] = toggleShowAllOptions;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t4 || $[15] !== t8 || $[16] !== t9) {
    t10 = <div>{t4}{t8}{t9}</div>;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
DesktopProductListingListFilter.propTypes = {
  id: PropTypes.string
};
export default DesktopProductListingListFilter;
function _temp(prevShowAllOptions) {
  return !prevShowAllOptions;
}